<button *renderInAppActionsMain ideal-cart-menu-button (click)="toggleCart()" [open]="isOpen()"></button>
<ideal-cart-menu *appSideDrawer="'cart'" />
